/** Shared defaults for the milestone / cart-goal product block widget */

export interface MilestoneDesign {
  /** Fallback title when no progress copy is available */
  fallbackTitle: string;
  /** Chip / banner details button label */
  detailsLabel: string;
  /** Details panel heading */
  detailsTitle: string;
  accentColor: string;
  lineColor: string;
  backgroundColor: string;
  textColor: string;
  mutedColor: string;
  borderRadius: number;
  maxWidth: number;
  showChip: boolean;
  showDetails: boolean;
  fontFamily: string;
  /** When true, storefront uses the live theme scheme (Product information first) */
  autoFitTheme: boolean;
  /** Scheme id from last Refresh — pinned for storefront Auto-fit */
  themeSchemeId: string | null;
  /**
   * “See details” open panel colors (milestone only).
   * Independent of main bar / Auto-fit theme tokens.
   */
  detailsBackgroundColor: string;
  detailsTextColor: string;
  detailsMutedColor: string;
  detailsBorderColor: string;
  detailsItemBackgroundColor: string;
  detailsAccentColor: string;
}

export const DEFAULT_MILESTONE_DESIGN: MilestoneDesign = {
  fallbackTitle: 'Unlock free gifts as you spend',
  detailsLabel: 'See details',
  detailsTitle: 'Reward tiers',
  accentColor: '#1A1A1A',
  lineColor: '#1A1A1A',
  backgroundColor: '#F5F0E6',
  textColor: '#1A1A1A',
  mutedColor: '#6B6B6B',
  borderRadius: 16,
  maxWidth: 560,
  showChip: true,
  showDetails: true,
  fontFamily:
    'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  autoFitTheme: true,
  themeSchemeId: null,
  detailsBackgroundColor: '#FFFFFF',
  detailsTextColor: '#1A1A1A',
  detailsMutedColor: '#6B6B6B',
  detailsBorderColor: '#E5E5E5',
  detailsItemBackgroundColor: '#FFFFFF',
  detailsAccentColor: '#1A1A1A',
};

/** Demo tiers for admin live preview */
export const DEMO_MILESTONE_TIERS = [
  {
    id: 't1',
    threshold: 50,
    label: '10% off',
    rewardType: 'order_discount',
    unlocked: false,
    isNext: true,
  },
  {
    id: 't2',
    threshold: 100,
    label: 'Free gift',
    rewardType: 'free_gift',
    unlocked: false,
    isNext: false,
  },
  {
    id: 't3',
    threshold: 150,
    label: 'Free shipping',
    rewardType: 'free_shipping',
    unlocked: false,
    isNext: false,
  },
];

export { toColorInputValue } from './popupDefaults';
